import Rest from 'services/data/rest';
import axios from 'axios';

export default class MonitoringAlert extends Rest {
  static path = 'monitoringalert';

  static claim(id) {
    return axios.post(`/api/monitoringalert/${id}/claim`);
  }
}
